import { CampaignConditionNewFormat, TransactionItem } from "types/campaigns";
import { BadgeParam } from "./Params/BadgeParam";
import { TransactionFilterParam } from "./Params/TransactionFilterParam";
import { WalletParam } from "./Params/WalletParam";

interface Props {
  ruleData: CampaignConditionNewFormat;
  transactionItemsFilters?: TransactionItem[];
  fieldKey: string;
}

export const Params = ({
  ruleData,
  transactionItemsFilters,
  fieldKey,
}: Props) => {
  const { field } = ruleData.value;

  switch (field) {
    case "transaction.items.qty":
    case "transaction.items.grossValue":
      return (
        <TransactionFilterParam
          fieldKey={fieldKey}
          transactionItemsFilters={transactionItemsFilters}
        />
      );
    case "customer.wallets.activeUnits":
    case "customer.wallets.expiredUnits":
    case "customer.wallets.blockedUnits":
    case "customer.wallets.lockedUnits":
    case "customer.wallets.earnedUnits":
    case "customer.wallets.spentUnits":
    case "referrer.wallets.activeUnits":
    case "referrer.wallets.expiredUnits":
    case "referrer.wallets.blockedUnits":
    case "referrer.wallets.lockedUnits":
    case "referrer.wallets.earnedUnits":
    case "referrer.wallets.spentUnits":
      return <WalletParam fieldKey={fieldKey} ruleData={ruleData} />;
    case "customer.badges":
    case "referrer.badges":
      return <BadgeParam fieldKey={fieldKey} ruleData={ruleData} />;
    default:
      return null;
  }
};
